/* MelomyPet Bakım Kitabı 2026 — page compositions.
   Every page is composed on a 210 × 210 mm square (CSS mm units = print units). Elements that must reach the trim
   edge extend 3 mm past it (bleed). Texts come only from MP.content[lang]; nothing language-specific lives here. */
window.MP = window.MP || {};
(function () {
  MP.VERSION = '2026-10-28.1';
  let T; // active language pack

  /* ---------- helpers ---------- */
  const I = MP.icon;
  const base = () => MP.imgBase || 'assets/img/lo';
  const ext = () => (MP.imgExt || 'webp');
  /* MP.imgURL (set on the store) maps 'concept/x.jpg' to its Shopify Files address */
  const src = (path) => (MP.imgURL ? MP.imgURL(path) : `${base()}/${path}`);
  const pack = (sku) => src(`products/${MP.products[sku].img}.${ext()}`);
  const concept = (n) => src(`concept/${n}.jpg`);
  const brand = (n) => src(`brand/${n}`);
  const pname = (sku) => T.p[sku].name;
  const pshort = (sku) => T.p[sku].short || T.p[sku].name;
  const pageRef = (n) => `<span class="pref">${T.meta.pageWord}&nbsp;${n}</span>`;
  const eyebrow = (txt, cls = '') => `<p class="eyebrow ${cls}">${I.pawFill()}<span>${txt}</span></p>`;
  const chips = (list, cls = '') => `<div class="chips ${cls}">${list.map((x) => `<span class="chip">${x}</span>`).join('')}</div>`;
  const metaInline = (sku) => `<span class="meta-in">${T.meta.sku}&nbsp;${sku} · ${MP.products[sku].barcode}</span>`;
  const meta = (sku, cls = '') => `<p class="meta ${cls}"><span>${T.meta.sku}&nbsp;${sku}</span><span>${T.meta.barcode}&nbsp;${MP.products[sku].barcode}</span></p>`;
  const who = (sku, cls = '') => {
    const p = MP.products[sku];
    if (!p.dog && !p.cat) return `<span class="who home ${cls}">${I.home()}${T.meta.forHome}</span>`;
    const label = p.dog && p.cat ? T.meta.forBoth : p.dog ? T.meta.forDog : T.meta.forCat;
    return `<span class="who ${cls}">${p.dog ? I.dog() : ''}${p.cat ? I.cat() : ''}${label}</span>`;
  };
  const size = (sku) => `<span class="size">${MP.products[sku].size}</span>`;
  const img = (src, cls = '', style = '', alt = '') => `<img class="${cls}" src="${src}" style="${style}" alt="${alt}" decoding="async">`;
  const packImg = (sku, style, cls = '') => `<img class="pack ${cls}" src="${pack(sku)}" style="${style}" alt="${pname(sku)}" decoding="async">`;
  /* contact shadow under a packshot: centred on x, sitting on y (mm) */
  const shadow = (x, y, w, o = 0.32) => `<i class="contact" style="left:${x - w / 2}mm;top:${y - w * 0.09}mm;width:${w}mm;height:${w * 0.18}mm;--o:${o}"></i>`;
  const hand = (text, arrow, style, cls = '') => `<div class="hand ${cls}" style="${style}"><span>${text}</span>${arrow ? MP.handArrow(arrow) : ''}</div>`;
  const steps = (list, cls = '') => `<ol class="steps ${cls}">${list.map((s, i) => `<li><b class="n">${String(i + 1).padStart(2, '0')}</b><div><h5>${s[0]}</h5><p>${s[1]}</p></div></li>`).join('')}</ol>`;
  const arch = (style, cls = '') => `<div class="arch ${cls}" style="${style}"></div>`;
  /* spread image: one picture across both pages; each page shows its half (+ bleed) */
  const spreadImg = (name, side, pos = '50% 50%') => `<div class="sp-img ${side}"><img src="${concept(name)}" style="object-position:${pos}" alt="" decoding="async"></div>`;
  /* a photograph in a box (page mm). The products are photographed inside the scene (src/concept/sc-*), never pasted. */
  const photo = (name, style, pos = '50% 50%', cls = '') => `<div class="photo ${cls}" style="${style}"><img src="${concept(name)}" style="object-position:${pos}" alt="" decoding="async"></div>`;
  /* a closer crop of the same photograph: z = magnification, at = the point that stays in view (x% y%) */
  const fullImg = (name, pos = '50% 50%', extra = '') => `<div class="full-img"><img src="${concept(name)}" style="object-position:${pos};${extra}" alt="" decoding="async"></div>`;
  const chLabel = (ch, cls = '') => `<p class="ch-label ${cls}"><b>${T.chapters[ch].no}</b><span>${T.chapters[ch].short}</span></p>`;

  /* ---------- pages ---------- */
  const P = [];
  const page = (n, opt, render) => P.push({ n, ...opt, render });

  /* 1 — COVER */
  page(1, { cls: 'pg-cover', folio: false }, () => `
    ${fullImg('cover', '50% 100%', 'height:228mm;top:-3mm')}
    <div class="cover-top">
      <span class="issue">${T.cover.issue}</span>
      <img class="logo" src="${brand('studio-logo.svg')}" alt="MelomyPet">
      <span class="edition">${T.cover.edition}</span>
    </div>
    ${eyebrow(T.cover.eyebrow, 'cover-eyebrow')}
    <h1 class="cover-title">${T.cover.title}</h1>
    <p class="cover-sub">${T.cover.sub}</p>
    ${hand(T.cover.melo, 'a', 'left:13mm;top:121mm', 'cover-name melo')}
    ${hand(T.cover.dodi, 'b', 'left:170mm;top:104mm', 'cover-name dodi')}
    <p class="cover-url">${T.cover.url}</p>`);

  /* 2 — ENDPAPER + ex libris */
  page(2, { cls: 'pg-endpaper', folio: false }, () => `
    <div class="bleed lav">${MP.pattern('pat-end', '#39234B', 0.16)}</div>
    <div class="exlibris">
      <div class="ex-badge">${I.pawFill()}</div>
      <p class="ex-q">${T.endpaper.q}</p>
      <dl>
        <div><dt>${T.endpaper.human}</dt><dd></dd></div>
        <div><dt>${T.endpaper.pet}</dt><dd></dd></div>
        <div><dt>${T.endpaper.since}</dt><dd></dd></div>
      </dl>
      <div class="ex-print"><span>${MP.icon.paw()}</span></div>
      ${hand(T.endpaper.printHere, 'd', 'left:22mm;top:113mm', 'row small')}
    </div>
    <p class="end-foot">${T.endpaper.foot}</p>`);

  /* 3 — GÜNAYDIN (welcome letter) */
  page(3, { cls: 'pg-hello', folio: true }, () => `
    <div class="hello-sun">${I.sunrise()}</div>
    <p class="hello-time">${T.hello.time}</p>
    <h2 class="hello-title">${T.hello.title}</h2>
    <div class="hello-body">${T.hello.body.map((p) => `<p>${p}</p>`).join('')}</div>
    <div class="hello-sign">
      <p class="s1">${T.hello.sign}</p>
      <p class="s2">${T.hello.signers}</p>
      <span class="paws"><i class="melo">${I.pawFill()}</i><i class="dodi">${I.pawFill()}</i></span>
    </div>
    <div class="paw-trail hello-trail">${[0, 1, 2, 3, 4, 5].map((i) => `<i style="left:${i * 11}mm;top:${-i * 4.6 + (i % 2) * 4}mm;transform:rotate(${62 + (i % 2) * 22}deg)">${I.pawFill()}</i>`).join('')}</div>
    ${seal('right:14mm;top:132mm')}`);

  function seal(style) {
    const txt = `${T.meta.running} · ${T.meta.edition} · `;
    return `<svg class="seal" style="${style}" viewBox="0 0 100 100" aria-hidden="true"><defs><path id="seal-c" d="M50 50m-37 0a37 37 0 1 1 74 0a37 37 0 1 1-74 0"/></defs>
      <circle cx="50" cy="50" r="48" fill="var(--lime)"/><circle cx="50" cy="50" r="27" fill="none" stroke="var(--ink)" stroke-width="0.8" stroke-dasharray="1.6 2.4"/>
      <text font-family="Helvetica Neue, Arial" font-size="7.2" font-weight="700" letter-spacing="2.1" fill="var(--ink)"><textPath href="#seal-c">${txt.toLocaleUpperCase(T.meta.locale)}</textPath></text>
      <g transform="translate(36 36) scale(1.18)" color="var(--ink)">${I.pawFill().replace('class="ico"', 'width="24" height="24"')}</g></svg>`;
  }

  /* 4–5 — CONTENTS: one photograph of the day across the spread (a time-slice of one room, from sunrise at the door on
     the left to night by the dog bed on the right); the eight stops hang on its wall as a timeline, each in its own light */
  const tocStops = () => T.toc.stops;
  const TOC_X = [38, 84, 124, 164, 258, 298, 325, 357];   // spread mm: clear of the leash and both windows
  const TOC_Y = 64;                                        // the timeline, mm from the top
  const tocIcons = ['sunrise', 'sun', 'sun', 'sun', 'sun', 'sunrise', 'moon', 'moon'];
  function tocHalf(side) {
    const off = side === 'left' ? 0 : 210;
    const stops = tocStops().map((s, i) => ({ ...s, x: TOC_X[i], icon: tocIcons[i], i }))
      .filter((s) => (side === 'left' ? s.x < 210 : s.x > 210));
    return `${spreadImg('toc-gun', side, '50% 100%')}
      <div class="toc-line ${side}" style="top:${TOC_Y}mm"></div>
      ${stops.map((s) => `<div class="toc-stop ${s.i >= 6 ? 'night' : ''}" style="left:${s.x - off}mm;top:${TOC_Y}mm">
          <span class="toc-dot">${I[s.icon]()}</span>
          <span class="toc-time">${s.time}</span>
          <span class="toc-name">${s.name}</span>
          <span class="toc-desc">${s.desc}</span>
          <span class="toc-page">${T.meta.pageWord} ${s.page}</span>
        </div>`).join('')}`;
  }
  page(4, { cls: 'pg-toc', folio: true }, () => `
    ${tocHalf('left')}
    ${eyebrow(T.toc.eyebrow, 'toc-eyebrow')}
    <h2 class="toc-title">${T.toc.title}</h2>
    <p class="toc-sub">${T.toc.sub}</p>`);
  page(5, { cls: 'pg-toc', folio: true, folioNight: true }, () => `
    ${tocHalf('right')}
    <div class="toc-also"><p class="h">${T.toc.alsoTitle}</p>${T.toc.also.map(([a, n]) => `<span><span>${a}</span><b>${n}</b></span>`).join('')}</div>
    <div class="toc-sets"><span class="ic">${I.gift()}</span><span class="t">${T.chapters[7].time}</span><b>${T.toc.sets.name}</b><span class="d">${T.toc.sets.desc}</span><span class="p">${T.meta.pageWord} ${T.toc.sets.page}</span></div>
    <p class="toc-credit">${T.toc.credit}</p>`);

  /* 6–7 — STORY */
  page(6, { cls: 'pg-story-l', folio: true }, () => `
    <div class="bleed lav"></div>
    <div class="squig">${MP.doodle.squiggle(150)}</div>
    <figure class="polaroid melo"><i class="tape"></i><img src="${brand('studio-melo.jpg')}" alt="Melo"><figcaption><b>${T.story.melo[0]}</b><span>${T.story.melo[1]}</span></figcaption></figure>
    <figure class="polaroid dodi"><i class="tape"></i><img src="${brand('studio-dodi.jpg')}" alt="Dodi"><figcaption><b>${T.story.dodi[0]}</b><span>${T.story.dodi[1]}</span></figcaption></figure>
    <div class="story-heart">${MP.doodle.heart()}</div>
    ${hand(T.story.hand, 'c', 'left:20mm;top:166mm', 'story-hand')}`);
  page(7, { cls: 'pg-story-r', folio: true }, () => `
    ${eyebrow(T.story.eyebrow)}
    <h2 class="story-title">${T.story.title}</h2>
    <div class="story-body">${T.story.body.map((p) => `<p>${p}</p>`).join('')}</div>
    <blockquote class="story-quote"><span>${T.story.quote}</span>${MP.doodle.underline(52)}</blockquote>
    <div class="story-stats">${T.story.stats.map(([n, l]) => `<div><b>${n}</b><span>${l}</span></div>`).join('')}</div>`);

  /* 8–9 — CARE MAP */
  const SPOTS = { /* point on Melo (mm, page coords) → label position */
    coat:  { pt: [123, 66],   lab: [150, 46],  side: 'r' },
    nose:  { pt: [109.6, 82.2], lab: [150, 80], side: 'r' },   /* right edge of the nose, not on top of it */
    skin:  { pt: [117, 122],  lab: [150, 114], side: 'r' },
    scent: { pt: [124, 134],  lab: [150, 148], side: 'r' },
    eye:   { pt: [95.2, 78.4], lab: [14, 60],  side: 'l' },   /* below the outer corner, never on the eye itself */
    mouth: { pt: [104.6, 88.4], lab: [14, 96], side: 'l' },
    paw:   { pt: [95, 141],   lab: [14, 134],  side: 'l' }
  };
  page(8, { cls: 'pg-map', folio: true }, () => `
    ${eyebrow(T.map.eyebrow)}
    <h2 class="map-title">${T.map.title}</h2>
    <p class="map-sub">${T.map.sub}</p>
    <div class="map-ring"></div>
    <div class="map-melo"><img src="${brand('studio-melo.jpg')}" alt="Melo"></div>
    <svg class="map-lines" viewBox="0 0 210 210" aria-hidden="true">${Object.values(SPOTS).map((s) => {
      const lx = s.side === 'r' ? s.lab[0] - 2 : s.lab[0] + 44; const ly = s.lab[1] + 3.2;
      return `<path d="M${s.pt[0]} ${s.pt[1]} L${lx} ${ly}" /><circle cx="${s.pt[0]}" cy="${s.pt[1]}" r="1.3"/>`;
    }).join('')}</svg>
    ${Object.entries(SPOTS).map(([k, s]) => `<div class="map-spot ${s.side}" style="left:${s.lab[0]}mm;top:${s.lab[1]}mm"><b>${T.map.spots[k][0]}</b><span>${T.map.spots[k][1]}</span><em>${T.meta.pageWord} ${T.map.spots[k][2]}</em></div>`).join('')}
    <div class="map-home"><span class="ic">${I.home()}</span><b>${T.map.home[0]}</b><span>${T.map.home[1]}</span><em>${T.meta.pageWord} ${T.map.home[2]}</em></div>`);
  page(9, { cls: 'pg-matrix', folio: true }, () => `
    <h3 class="matrix-title">${T.map.tableTitle}</h3>
    <table class="matrix">
      <thead><tr><th>${T.map.cols[0]}</th><th>${I.dog()}<span>${T.map.cols[1]}</span></th><th>${I.cat()}<span>${T.map.cols[2]}</span></th><th>${T.map.cols[3]}</th></tr></thead>
      ${T.map.groups.map(([g, skus], gi) => `<tbody><tr class="grp"><th colspan="4"><span style="--c:${MP.chapters[[1, 2, 3, 4, 6, 5][gi]].tint}">${g}</span></th></tr>
        ${skus.map((s) => {
          const p = MP.products[s];
          const nm = s === 'MLY09' ? T.map.perfumeRow : pname(s);
          const cells = p.area === 'home'
            ? `<td colspan="2" class="area">${I.home()}<span>${T.map.homeTags[s]}</span></td>`
            : `<td>${p.dog ? '<i class="on"></i>' : '<i></i>'}</td><td>${p.cat ? '<i class="on"></i>' : '<i></i>'}</td>`;
          return `<tr><td class="nm">${nm}</td>${cells}<td class="pg">${p.page}</td></tr>`;
        }).join('')}</tbody>`).join('')}
    </table>
    <p class="matrix-note">${I.noPet()}<span>${T.map.homeNote}</span></p>`);

  /* chapter opener helper (spread) */
  function openerLeft(ch, imgName, pos, extra = '') {
    return `${spreadImg(imgName, 'left', pos)}
      <div class="opener-text">
        ${chLabel(ch)}
        <p class="op-time">${T.chapters[ch].time}</p>
        <h2 class="op-title">${T.chapters[ch].name}.</h2>
        ${T['ch' + ch] && T['ch' + ch].intro ? `<p class="op-intro">${T['ch' + ch].intro}</p>` : ''}
      </div>${extra}`;
  }

  /* 10–11 — CH1 Yürüyüş dönüşü */
  page(10, { cls: 'pg-opener', ch: 1, folio: true }, () => openerLeft(1, 'ch-yuruyus', '50% 46%'));
  page(11, { cls: 'pg-opener', ch: 1, folio: true, folioLight: true }, () => `${spreadImg('ch-yuruyus', 'right', '50% 46%')}
    ${hand(T.ch1.hand, 'b', 'left:62mm;top:44mm', 'op-hand')}`);

  /* 12 — Pati Temizleme Köpüğü: Dodi on the doormat, the foam beside her */
  page(12, { cls: 'pg-hero pg-foam', ch: 1, folio: true }, () => `
    ${photo('sc-pati-kopuk', 'left:-3mm;top:-3mm;width:101mm;height:216mm', '50% 46%')}
    <div class="col" style="left:106mm;top:14mm;width:90mm">
      ${eyebrow(T.p.MLY07.type)}
      <h2 class="p-name">${pname('MLY07')}</h2>
      <p class="p-sub">${size('MLY07')}${who('MLY07')}</p>
      <p class="lead">${T.p.MLY07.lead}</p>
      <p class="body">${T.p.MLY07.body}</p>
      ${chips(T.p.MLY07.callouts.slice(0, 2), 'sm feat')}
      <p class="kh">${T.meta.keyIngredients}</p>${chips(T.p.MLY07.keys)}
    </div>
    ${steps(T.p.MLY07.steps, 'big" style="left:106mm;top:112mm;width:90mm')}
    ${meta('MLY07', 'abs" style="left:106mm;top:189mm')}
    <div class="paw-trail" style="left:150mm;top:184mm">${[0, 1, 2, 3].map((i) => `<i style="left:${i * 9}mm;top:${(i % 2) * 5}mm;transform:rotate(${70 + (i % 2) * 18}deg)">${I.pawFill()}</i>`).join('')}</div>`);

  /* 13 — two paw balms: Melo by the window, both sticks on the sill */
  const balmCol = (sku, x) => `
    <div class="col balm-col" style="left:${x}mm;top:133mm;width:84mm">
      <h3 class="p-name s">${pname(sku)}</h3>
      <p class="p-sub">${size(sku)}${who(sku)}</p>
      <p class="body">${T.p[sku].lead} ${T.p[sku].body}</p>
      <p class="kh">${T.paw.oils}</p>${chips(T.p[sku].keys, 'sm')}
      ${meta(sku)}
    </div>`;
  page(13, { cls: 'pg-balms', ch: 1, folio: true }, () => `
    ${photo('sc-balm', 'left:-3mm;top:-3mm;width:216mm;height:100mm', '50% 58%')}
    <div class="col" style="left:17mm;top:104mm;width:179mm">
      ${eyebrow(`${T.p.MLY14.type} · ${T.meta.forBoth}`)}
      <h2 class="sec-title s">${T.paw.balmTitle}</h2>
      <p class="sec-sub">${T.paw.balmSub}</p>
    </div>
    ${balmCol('MLY14', 17)}${balmCol('MLY06', 112)}
    <div class="usage-strip" style="left:17mm;top:189mm;width:179mm">${I.circleMotion()}<span>${T.paw.usage}</span></div>`);

  /* 14–15 — CH2 Banyo günü */
  page(14, { cls: 'pg-opener', ch: 2, folio: true }, () => openerLeft(2, 'ch-banyo', '50% 40%'));
  page(15, { cls: 'pg-opener', ch: 2, folio: true }, () => `${spreadImg('ch-banyo', 'right', '50% 40%')}
    ${hand(T.ch2.hand, 'a', 'left:122mm;top:142mm', 'op-hand')}`);

  /* 16–17 — four shampoos: each photographed in its own bath scene, interlocking with its copy */
  const shCopy = (sku, style) => `<div class="col sh-col" style="${style}">
      <p class="focus">${T.p[sku].focus}</p>
      <h3 class="p-name xs">${pname(sku)}</h3>
      <p class="p-sub">${size(sku)}${who(sku)}</p>
      <p class="body">${T.p[sku].body}</p>
      ${sku === 'MLY18' ? `<p class="inset-note">${I.gift()}${T.shampoos.inSet} · ${pageRef(43)}</p>` : ''}
      ${meta(sku)}
    </div>`;
  page(16, { cls: 'pg-shampoo', ch: 2, folio: true }, () => `
    <div class="col" style="left:14mm;top:14mm;width:150mm">
      ${eyebrow(T.shampoos.eyebrow)}
      <h2 class="sec-title">${T.shampoos.title}</h2>
      <p class="sec-sub" style="width:120mm">${T.shampoos.sub}</p>
    </div>
    ${photo('sc-sampuan-aynisafa', 'left:-3mm;top:58mm;width:99mm;height:99mm', '50% 52%', 'r-out')}
    ${shCopy('MLY01', 'left:104mm;top:62mm;width:92mm')}
    ${photo('sc-sampuan-hassas', 'left:128mm;top:112mm;width:68mm;height:68mm', '50% 48%', 'r')}
    ${shCopy('MLY21', 'left:14mm;top:163mm;width:104mm')}
    `);
  page(17, { cls: 'pg-shampoo', ch: 2, folio: true }, () => `
    <div class="pick" style="left:17mm;top:14mm;width:179mm">
      <p class="pick-h">${T.shampoos.pickTitle}</p>
      ${T.shampoos.picks.map(([q, sku]) => `<p class="pick-row"><span>${q}</span><i class="lead" aria-hidden="true"></i><b>${pshort(sku)}</b></p>`).join('')}
    </div>
    ${photo('sc-sampuan-kurk', 'left:17mm;top:62mm;width:76mm;height:76mm', '50% 50%', 'r')}
    ${shCopy('MLY18', 'left:101mm;top:64mm;width:95mm')}
    ${photo('sc-sampuan-kopek', 'left:121mm;top:110mm;width:92mm;height:89mm', '50% 46%', 'r-in')}
    ${shCopy('MLY19', 'left:17mm;top:144mm;width:96mm')}
    <p class="vet" style="left:17mm;top:189mm;width:96mm">${T.shampoos.vet}</p>`);

  /* 18 — ingredient spotlight: calendula & chamomile */
  page(18, { cls: 'pg-flowers', ch: 2, folio: true, folioLight: false }, () => `
    ${fullImg('ing-papatya', '50% 100%')}
    <div class="col" style="left:14mm;top:13mm;width:116mm">
      ${eyebrow(T.flowers.eyebrow)}
      <h2 class="sec-title">${T.flowers.title}</h2>
      <p class="sec-sub">${T.flowers.body}</p>
    </div>
    <div class="flower-list">${T.flowers.list.map((s) => `<div><span>${pname(s)}</span><b>${MP.products[s].page}</b></div>`).join('')}
      <p class="fl-note">${T.flowers.note}</p></div>
    `);

  /* 19 — bath ritual */
  page(19, { cls: 'pg-ritual', ch: 2, folio: true }, () => `
    ${arch('left:130mm;top:14mm;--w:66mm;height:98mm;overflow:hidden', 'photo-arch')}
    <img class="arch-img" src="${concept('golden')}" style="left:130mm;top:14mm;width:66mm;height:98mm;object-position:50% 30%;--w:66mm" alt="">
    <p class="caption" style="left:130mm;top:118mm;width:64mm">${T.ritual.caption}</p>
    ${hand(T.ritual.hand, 'e', 'left:132mm;top:146mm;width:60mm', 'small wrap')}
    <div class="col" style="left:17mm;top:14mm;width:106mm">
      ${eyebrow(T.ritual.eyebrow)}
      <h2 class="sec-title">${T.ritual.title}</h2>
    </div>
    <ol class="ritual">${T.ritual.steps.map(([h, p, sku], i) => `<li class="${i === 4 ? 'opt' : ''}"><b class="n">${String(i + 1).padStart(2, '0')}</b>
      <div class="tx"><h5>${h}${i === 4 ? `<em>${T.ritual.optional}</em>` : ''}</h5><p>${p}</p></div>
      ${sku ? `<div class="mini"><img src="${pack(sku)}" alt=""><span>${pageRef(MP.products[sku].page)}</span></div>` : ''}</li>`).join('')}</ol>`);

  /* 20 — Avokado Tüy Maskesi: the Afghan hound and the mask on one set */
  page(20, { cls: 'pg-mask', ch: 2, folio: true }, () => `
    ${photo('sc-avokado', 'left:-3mm;top:-3mm;width:216mm;height:108mm', '50% 54%')}
    <div class="col" style="left:14mm;top:112mm;width:112mm">
      ${eyebrow(`${T.p.MLY08.type} · ${T.meta.forDog}`)}
      <h2 class="p-name">${pname('MLY08')}</h2>
      <p class="p-sub">${size('MLY08')}${who('MLY08')}</p>
      <p class="lead">${T.p.MLY08.lead}</p>
      <p class="body">${T.p.MLY08.body}</p>
      ${chips(T.p.MLY08.keys, 'sm')}
    </div>
    ${steps(T.p.MLY08.steps, 'side" style="left:134mm;top:114mm;width:62mm')}
    ${meta('MLY08', 'abs" style="left:14mm;top:192.5mm')}`);

  /* 21 — Kıtık Açıcı Kolay Tarama Spreyi: the ragdoll, the comb and the spray */
  page(21, { cls: 'pg-comb', ch: 2, folio: true }, () => `
    ${photo('sc-kitik', 'left:113mm;top:-3mm;width:100mm;height:216mm', '50% 50%')}
    <div class="col" style="left:17mm;top:14mm;width:88mm">
      ${eyebrow(T.p.MLY16.type)}
      <p class="dist"><b>~20</b><span>cm</span></p>
      <p class="tag-rinse">${I.drop()}<span>${T.p.MLY16.steps[2][0]}</span></p>
      <h2 class="p-name s">${pname('MLY16')}</h2>
      <p class="p-sub">${size('MLY16')}${who('MLY16')}</p>
      <p class="body">${T.p.MLY16.body}</p>
      ${chips(T.p.MLY16.keys, 'sm')}
      ${steps(T.p.MLY16.steps.slice(0, 2), 'tight')}
      ${meta('MLY16')}
    </div>
    <div class="compare-card" style="left:17mm;top:150mm;width:88mm">
      <p class="cc-h">${T.mask.compareTitle}</p>
      ${T.mask.compare.map(([a, b]) => `<p><b>${a}</b><span>${b}</span></p>`).join('')}
    </div>`);

  /* 22–23 — between baths: Melo on the sofa with both products; close-ups of each on 23 */
  page(22, { cls: 'pg-between-img', ch: 2, folio: true }, () => `
    ${fullImg('sc-banyo-arasi', '50% 58%')}
    <div class="scrim-b"></div>
    <div class="col light" style="left:14mm;top:158mm;width:120mm">
      ${eyebrow(T.between.eyebrow, 'light')}
      <h2 class="sec-title light">${T.between.title}</h2>
    </div>
    ${hand(T.between.hand, 'd', 'left:118mm;top:146mm', 'light')}
    `);
  page(23, { cls: 'pg-between', ch: 2, folio: true }, () => `
    <p class="sec-sub" style="position:absolute;left:17mm;top:15mm;width:150mm">${T.between.sub}</p>
    <div class="hcard" style="left:17mm;top:32mm;width:179mm;height:75mm;background:var(--sky)">
      ${photo('sc-kopuk-detay', 'left:0;top:0;width:75mm;height:75mm', '50% 50%')}
      <div class="col" style="left:82mm;top:8mm;width:91mm">
        ${eyebrow(`${T.p.MLY15.type} · ${T.meta.forDog}`)}
        <h3 class="p-name s">${pname('MLY15')}</h3>
        <p class="p-sub">${size('MLY15')}${who('MLY15')}</p>
        <p class="body">${T.p.MLY15.lead} ${T.p.MLY15.body}</p>
        ${chips(T.p.MLY15.keys, 'sm')}
        ${meta('MLY15')}
      </div>
    </div>
    <div class="hcard" style="left:17mm;top:110mm;width:179mm;height:75mm;background:var(--lav)">
      ${photo('sc-lavanta-detay', 'left:0;top:0;width:75mm;height:75mm', '50% 50%')}
      <div class="col" style="left:82mm;top:8mm;width:91mm">
        ${eyebrow(`${T.p.MLY22.type} · ${T.meta.forBoth}`)}
        <h3 class="p-name s">${pname('MLY22')}</h3>
        <p class="p-sub">${size('MLY22')}${who('MLY22')}</p>
        <p class="body">${T.p.MLY22.lead} ${T.p.MLY22.body}</p>
        ${chips(T.p.MLY22.keys, 'sm')}
        ${meta('MLY22')}
      </div>
    </div>
    <p class="xref" style="left:17mm;top:189mm">${I.gift()}<span>${T.between.setRef}</span>${pageRef(43)}</p>`);

  /* 24–25 — CH3 Yakın bakım */
  page(24, { cls: 'pg-opener single', ch: 3, folio: true }, () => `
    ${fullImg('yakin-burun', '70% 50%')}
    <div class="opener-text" style="top:30mm;width:84mm">
      ${chLabel(3)}
      <p class="op-time">${T.chapters[3].time}</p>
      <h2 class="op-title">${T.chapters[3].name}.</h2>
      <p class="op-intro" style="max-width:66mm">${T.ch3.intro}</p>
    </div>
    `);
  page(25, { cls: 'pg-nose', ch: 3, folio: true }, () => `
    ${photo('sc-burun', 'left:111mm;top:-3mm;width:102mm;height:216mm', '50% 42%')}
    <div class="col" style="left:17mm;top:14mm;width:86mm">
      ${eyebrow(`${T.p.MLY20.type} · ${T.meta.forDog}`)}
      <h2 class="p-name">${pname('MLY20')}</h2>
      <p class="p-sub">${size('MLY20')}${who('MLY20')}</p>
      <p class="lead">${T.p.MLY20.lead}</p>
      <p class="body">${T.p.MLY20.body}</p>
      <p class="warn">${I.dog()}<span>${T.nose.only}</span></p>
      ${steps(T.p.MLY20.steps, 'tight')}
      ${meta('MLY20')}
    </div>
    <p class="vet" style="left:17mm;top:181mm;width:86mm">${T.nose.vet}</p>
    ${hand(T.ch3.hand, '', 'left:20mm;top:160mm;width:80mm', 'small wrap')}`);

  /* 26 — eye area: Melo on the dresser beside the bottle and the pad jar */
  page(26, { cls: 'pg-eye', ch: 3, folio: true }, () => `
    ${photo('sc-goz', 'left:-3mm;top:-3mm;width:216mm;height:108mm', '50% 50%')}
    <div class="col" style="left:14mm;top:112mm;width:104mm">
      ${eyebrow(`${T.p.MLY17.type} · ${T.meta.forBoth}`)}
      <h2 class="p-name s">${pname('MLY17')}</h2>
      <p class="p-sub">${size('MLY17')}${who('MLY17')}</p>
      <p class="lead">${T.p.MLY17.lead}</p>
      <p class="body">${T.p.MLY17.body}</p>
      ${chips(T.p.MLY17.keys, 'sm')}
    </div>
    ${steps(T.p.MLY17.steps, 'side" style="left:126mm;top:114mm;width:70mm')}
    <p class="warn abs" style="left:14mm;top:186mm;width:112mm">${I.eye()}<span>${T.eye.warn}</span></p>
    ${meta('MLY17', 'abs right" style="right:14mm;top:192.5mm')}`);

  /* 27 — skin gel + zones: the ginger cat on the bed, the gel beside an aloe leaf */
  page(27, { cls: 'pg-skin', ch: 3, folio: true }, () => `
    ${photo('sc-jel', 'left:-3mm;top:-3mm;width:216mm;height:95mm', '50% 58%')}
    <div class="col" style="left:17mm;top:99mm;width:100mm">
      ${eyebrow(`${T.p.MLY02.type} · ${T.meta.forBoth}`)}
      <h2 class="p-name s">${pname('MLY02')}</h2>
      <p class="p-sub">${size('MLY02')}${who('MLY02')}</p>
      <p class="lead">${T.p.MLY02.lead}</p>
      <p class="body">${T.p.MLY02.body}</p>
      ${chips(T.p.MLY02.keys, 'sm')}
      ${meta('MLY02')}
    </div>
    ${steps(T.p.MLY02.steps, 'side" style="left:126mm;top:101mm;width:70mm')}
    <div class="zones" style="left:17mm;top:152mm;width:179mm">
      <p class="z-h">${T.skin.zonesTitle}</p>
      <div class="z-row">${T.skin.zones.map(([z, sku]) => `<div><img src="${pack(sku)}" alt=""><div><b>${z}</b><span>${pshort(sku)}</span><em>${pageRef(MP.products[sku].page)}</em></div></div>`).join('')}</div>
    </div>
    <p class="vet" style="left:17mm;top:190mm;width:170mm">${T.skin.vet}</p>`);

  /* 28–29 — CH4 Koku rafı: one still life across the spread; the middle of the frame (the gutter) is left empty */
  page(28, { cls: 'pg-koku', ch: 4, folio: true }, () => `${spreadImg('sc-koku-acilis', 'left', '50% 60%')}
    <div class="opener-text koku-title" style="top:15mm">
      ${chLabel(4)}
      <p class="op-time">${T.chapters[4].time}</p>
      <h2 class="op-title">${T.ch4.title}</h2>
      <p class="op-intro big">${T.ch4.sub}</p>
    </div>`);
  page(29, { cls: 'pg-koku', ch: 4, folio: true }, () => `${spreadImg('sc-koku-acilis', 'right', '50% 60%')}
    <p class="koku-who" style="right:17mm;top:20mm">${T.scents.who}</p>
    <div class="koku-next" style="right:17mm;top:28mm">${T.scents.title}<b>${pageRef(30)}</b></div>
    `);

  /* 30–31 — five scents: each bottle photographed with its own notes, a gallery hung at different heights */
  const SCENE = { MLY09: 'sc-koku-lucky', MLY10: 'sc-koku-baby', MLY11: 'sc-koku-monami', MLY12: 'sc-koku-weekend', MLY23: 'sc-koku-bella' };
  const scentTile = (sku, x, y, w = 56) => {
    const s = MP.scents[sku], h = w * 1.25;
    return `${photo(SCENE[sku], `left:${x}mm;top:${y}mm;width:${w}mm;height:${h}mm`, '50% 50%', 'r')}
      <div class="col scent-col" style="left:${x}mm;top:${y + h + 5}mm;width:${w}mm;--deep:${s.deep}">
        <h3 class="scent-name">${T.p[sku].name}</h3>
        <p class="scent-char">${T.p[sku].character}</p>
        ${[['top', 0], ['mid', 1], ['base', 2]].map(([k, i]) => `<div class="tier t${i}"><p class="tier-h"><i></i>${T.scents.tiers[i]}</p><p class="tier-n">${T.p[sku][k]}</p></div>`).join('')}
        ${meta(sku)}
      </div>`;
  };
  page(30, { cls: 'pg-scents', ch: 4, folio: true }, () => `
    <div class="col" style="left:14mm;top:14mm;width:56mm">
      ${eyebrow(T.scents.eyebrow)}
      <h2 class="sec-title s">${T.scents.title}</h2>
      <p class="sec-sub sm">${T.scents.sub}</p>
      <div class="use-list">${T.scents.use.map(([a, b], i) => `<p>${[I.ruler(), I.scent(), I.eye()][i]}<b>${a}</b><span>${b}</span></p>`).join('')}<p class="avoid">${I.noPet()}<span>${T.scents.avoid}</span></p></div>
      <p class="resp">${T.scents.note}</p>
      <div class="read-notes"><p class="rn-h">${T.scents.readTitle}</p>${T.scents.read.map(([a, b], i) => `<p class="rn t${i}"><i></i><b>${a}</b><span>${b}</span></p>`).join('')}</div>
    </div>
    ${scentTile('MLY09', 77, 14)}${scentTile('MLY10', 140, 32)}`);
  page(31, { cls: 'pg-scents', ch: 4, folio: true }, () => `${scentTile('MLY11', 17, 26)}${scentTile('MLY12', 79, 14)}${scentTile('MLY23', 141, 34)}
    `);

  /* 32–33 — CH5 Evde */
  page(32, { cls: 'pg-opener', ch: 5, folio: true }, () => openerLeft(5, 'ch-evde', '50% 62%'));
  page(33, { cls: 'pg-opener', ch: 5, folio: true }, () => `${spreadImg('ch-evde', 'right', '50% 62%')}
    ${hand(T.ch5.hand, 'b', 'left:78mm;top:36mm', 'op-hand')}`);

  /* 34 — stain + room spray: both in Dodi's living room */
  const homeCol = (sku, x, extra = '') => `
    <div class="col" style="left:${x}mm;top:143mm;width:86mm">
      <h3 class="p-name xs">${pname(sku)}</h3>
      <p class="p-sub">${size(sku)}${who(sku)}</p>
      <p class="body">${T.p[sku].body}</p>
      ${extra}
      ${meta(sku)}
    </div>`;
  page(34, { cls: 'pg-home', ch: 5, folio: true }, () => `
    ${photo('sc-evde', 'left:-3mm;top:-3mm;width:216mm;height:110mm', '50% 56%')}
    <div class="sticker" style="left:161mm;top:88mm">${I.noPet()}<span>${T.meta.notOnPet}</span></div>
    <div class="col" style="left:14mm;top:111mm;width:140mm">
      ${eyebrow(T.home.eyebrow)}
      <h2 class="sec-title s">${T.home.title}</h2>
      <p class="sec-sub">${T.home.sub}</p>
    </div>
    ${homeCol('MLY05', 14, `<p class="mini-note">${I.check()}${T.home.tryCorner}</p>`)}
    ${homeCol('MLY04', 110)}
    <p class="vet haz" style="left:14mm;top:186mm;width:182mm"><b>${pname('MLY05')} · ${T.home.hazardWord}.</b> ${T.home.hazard}</p>`);

  /* 35 — litter deodoriser */
  page(35, { cls: 'pg-litter', ch: 5, folio: true }, () => `
    ${photo('sc-kum', 'left:-3mm;top:-3mm;width:216mm;height:84mm', '50% 64%')}
    <div class="col" style="left:17mm;top:88mm;width:106mm">
      ${eyebrow(`${T.p.MLY26.type} · ${T.meta.forCat}`)}
      <h2 class="p-name s">${pname('MLY26')}</h2>
      <p class="p-sub"><span class="size">${MP.products.MLY26.size} · ${T.p.MLY26.sub}</span>${who('MLY26')}</p>
      <p class="body">${T.p.MLY26.body}</p>
      ${meta('MLY26')}
    </div>
    <dl class="facts" style="left:136mm;top:126mm;width:60mm">${T.p.MLY26.facts.map(([a, b]) => `<div><dt>${a}</dt><dd>${b}</dd></div>`).join('')}</dl>
    ${steps(T.p.MLY26.steps, 'row4" style="left:17mm;top:146mm;width:112mm')}
    <div class="vs" style="left:17mm;top:178mm;width:179mm">
      <p class="vs-h">${T.litter.compareTitle}</p>
      ${T.litter.compare.map(([a, b, sku]) => `<div><b>${a}</b><span>${b}</span><em>${pshort(sku)} · ${pageRef(MP.products[sku].page)}</em></div>`).join('')}
    </div>
`);

  /* 36–37 — toilet training */
  page(36, { cls: 'pg-train-img', ch: 5, folio: true }, () => `
    ${fullImg('sc-egitim', '50% 66%')}
    <div class="col" style="left:14mm;top:16mm;width:120mm">
      ${eyebrow(T.training.eyebrow)}
      <h2 class="op-title m">${T.training.title}</h2>
    </div>
    ${hand(T.training.hand, 'b', 'left:104mm;top:60mm', '')}
    `);
  page(37, { cls: 'pg-train', ch: 5, folio: true }, () => `
    ${photo('studio-tuvalet-egitim-spreyi', 'left:17mm;top:14mm;width:56mm;height:100mm', '50% 50%', 'r')}
    <div class="col" style="left:82mm;top:14mm;width:114mm">
      ${eyebrow(`${T.p.MLY13.type} · ${T.meta.forDog}`)}
      <h2 class="p-name">${pname('MLY13')}</h2>
      <p class="p-sub">${size('MLY13')}${who('MLY13')}<span class="who home">${I.noPet()}${T.meta.notOnPet}</span></p>
      <p class="lead">${T.p.MLY13.lead}</p>
      <p class="body">${T.p.MLY13.body}</p>
      ${meta('MLY13')}
      <div class="where">
        <p class="yes">${I.pad()}<b>${T.training.whereYes[0]}</b><span>${T.training.whereYes[1]}</span></p>
        <p class="no">${I.noPet()}<b>${T.training.whereNo[0]}</b><span>${T.training.whereNo[1]}</span></p>
      </div>
    </div>
    ${steps(T.p.MLY13.steps, 'grid2" style="left:17mm;top:124mm;width:179mm')}
    <div class="patience" style="left:17mm;top:163mm;width:179mm">${I.heart()}<div><b>${T.training.patienceTitle}</b><span>${T.training.patience}</span></div></div>`);

  /* 38–39 — CH6 Diş saati */
  page(38, { cls: 'pg-opener single', ch: 6, folio: true }, () => `
    ${fullImg('ch-dis-b', '50% 50%')}
    <div class="opener-text" style="top:16mm;width:120mm">
      ${chLabel(6)}
      <p class="op-time">${T.chapters[6].time}</p>
      <h2 class="op-title">${T.chapters[6].name}.</h2>
    </div>
    `);
  page(39, { cls: 'pg-oral', ch: 6, folio: true }, () => `
    ${photo('sc-dis', 'left:118mm;top:-3mm;width:95mm;height:110mm', '42% 50%')}
    <div class="col" style="left:17mm;top:14mm;width:94mm">
      <p class="lead">${T.ch6.intro}</p>
      <h2 class="sec-title">${T.oral.title}</h2>
    </div>
    <table class="vs-table" style="left:17mm;top:116mm;width:179mm">
      <thead><tr><th></th><th>${pname('MLY24')}<small>${MP.products.MLY24.size} · ${metaInline('MLY24')}</small></th><th>${pname('MLY03')}<small>${MP.products.MLY03.size} · ${metaInline('MLY03')}</small></th></tr></thead>
      <tbody>${T.oral.rows.map((r) => `<tr><th>${r[0]}</th><td>${r[1]}</td><td>${r[2]}</td></tr>`).join('')}</tbody>
    </table>
    <p class="vet" style="left:17mm;top:70mm;width:90mm">${T.oral.vet}</p>
    ${hand(T.ch6.hand, 'c', 'left:22mm;top:90mm;width:80mm', 'small wrap')}`);

  /* 40–43 — sets */
  const REL = { MLY01: 16, MLY21: 16, MLY18: 16, MLY19: 16, MLY08: 18, MLY07: 17, MLY15: 17, MLY14: 9.5, MLY06: 9.5, MLY20: 9.5, MLY02: 11, MLY03: 11, MLY17: 7.5, MLY04: 22, MLY05: 21, MLY13: 15, MLY16: 18, MLY22: 11.5, MLY24: 14, MLY26: 15 };
  function cluster(items, x, baseY, maxH, gap = -0.18, maxW = 999) {
    const top = Math.max(...items.map((s) => REL[s]));
    let hs = items.map((s) => (REL[s] / top) * maxH);
    let ws = items.map((s, i) => hs[i] * MP.ratio[s]);
    const span = () => ws.reduce((a, b) => a + b, 0) * (1 + gap) - ws[ws.length - 1] * gap;
    if (span() > maxW) { const k = maxW / span(); hs = hs.map((h) => h * k); ws = ws.map((w) => w * k); }
    const total = span();
    let cx = x - total / 2;
    return items.map((s, i) => {
      const html = `<img class="pack cl" src="${pack(s)}" style="left:${cx}mm;top:${baseY - hs[i]}mm;height:${hs[i]}mm;z-index:${10 + (i % 2 ? 1 : 2)}" alt="${pname(s)}">`;
      cx += ws[i] * (1 + gap); return html;
    }).join('') + shadow(x, baseY, total * 0.95, 0.3);
  }
  page(40, { cls: 'pg-sets-img', ch: 7, folio: true }, () => `
    ${fullImg('setler', '50% 70%')}
    <div class="opener-text" style="top:16mm;width:150mm">
      ${chLabel(7)}
      <h2 class="op-title">${T.ch7.title}</h2>
      <p class="op-intro big">${T.ch7.sub}</p>
    </div>
    ${hand(T.ch7.hand, 'b', 'left:122mm;top:58mm', '')}
    `);
  const bigSet = (code, y, bg) => {
    const s = MP.sets[code];
    return `<div class="set-big" style="top:${y}mm">
      <div class="sb-stage" style="background:${bg}">${photo('sc-set-' + code, 'inset:0', '50% 60%')}</div>
      <div class="sb-text">
        <p class="count"><b>${s.items.length}</b> ${T.itemWord}</p>
        <h3 class="p-name xs">${T.sets[code].name}</h3>
        <p class="p-sub"><span class="who">${s.dog ? I.dog() : ''}${s.cat ? I.cat() : ''}${T.sets[code].who}</span></p>
        <p class="body">${T.sets[code].note}</p>
        <ol class="contents">${s.items.map((i) => `<li><span>${pname(i)}</span><b>${MP.products[i].page}</b></li>`).join('')}</ol>
        <p class="meta"><span>${T.meta.sku}&nbsp;${code}</span></p>
      </div></div>`;
  };
  page(41, { cls: 'pg-sets-big', ch: 7, folio: true }, () => `
    ${eyebrow(T.chapters[7].name, 'abs" style="left:17mm;top:14mm')}
    <h2 class="sec-title abs" style="left:17mm;top:19mm">${T.setsPage.bigTitle}</h2>
    ${bigSet('MLY101', 36, 'var(--lav)')}${bigSet('MLY102', 114, 'var(--peach)')}`);
  const smallSet = (code, x, y, bg, stageH = 40, pos = '50% 58%') => {
    const s = MP.sets[code];
    return `<div class="set-sm" style="left:${x}mm;top:${y}mm">
      <div class="ss-stage" style="background:${bg};height:${stageH}mm">${photo('sc-set-' + code, 'inset:0', pos)}</div>
      <p class="count"><b>${s.items.length}</b> ${T.itemWord}</p>
      <h3 class="p-name xxs">${T.sets[code].name}</h3>
      <p class="ss-who">${T.sets[code].who}</p>
      <p class="ss-note">${T.sets[code].note}</p>
      <ul class="contents sm">${s.items.map((i) => `<li><span>${pshort(i)}</span><b>${MP.products[i].page}</b></li>`).join('')}</ul>
      <p class="meta"><span>${T.meta.sku}&nbsp;${code}</span></p>
    </div>`;
  };
  page(42, { cls: 'pg-sets-sm', ch: 7, folio: true }, () => `
    <div class="col" style="left:14mm;top:14mm;width:180mm">
      ${eyebrow(T.chapters[7].name)}
      <h2 class="sec-title">${T.setsPage.smallTitle}</h2>
      <p class="sec-sub">${T.setsPage.smallSub}</p>
    </div>
    ${smallSet('MLY109', 14, 62, 'var(--sage)', 66)}${smallSet('MLY108', 108, 62, 'var(--lav)', 66)}`);
  page(43, { cls: 'pg-sets-sm', ch: 7, folio: true }, () => `
    ${smallSet('MLY107', 17, 14, 'var(--peach)', 43, '50% 40%')}${smallSet('MLY106', 108, 14, 'var(--lav)', 43)}
    ${smallSet('MLY105', 17, 107, 'var(--butter)', 43, '50% 40%')}${smallSet('MLY103', 108, 107, 'var(--sky)', 43)}`);

  /* 44 — moments */
  const MOMENT_ICON = { paw: 'paw', bath: 'bath', comb: 'comb', bubbles: 'bubbles', nose: 'nose', eye: 'eye', scent: 'scent', moon: 'moon', drop: 'drop', home: 'home' };
  page(44, { cls: 'pg-moments', ch: 8, folio: true }, () => `
    <div class="col" style="left:14mm;top:14mm;width:180mm">
      ${eyebrow(T.moments.eyebrow)}
      <h2 class="sec-title">${T.moments.title}</h2>
      <p class="sec-sub">${T.moments.sub}</p>
    </div>
    <div class="moments">${T.moments.list.map(([m, skus, ic]) => `<div class="mo">
      <span class="mo-ic">${I[MOMENT_ICON[ic]]()}</span>
      <div class="mo-tx"><b>${m}</b>${skus.map((s) => `<span><span>${s === 'MLY09' ? T.map.perfumeRow : pshort(s)}</span><em>${MP.products[s].page}</em></span>`).join('')}</div>
      <div class="mo-packs">${skus.map((s) => `<img src="${pack(s)}" alt="">`).join('')}</div></div>`).join('')}</div>`);

  /* 45 — notes & safety */
  page(45, { cls: 'pg-notes', ch: 8, folio: true }, () => `
    <div class="avatars"><img src="${brand('studio-melo.jpg')}" alt="Melo"><img src="${brand('studio-dodi.jpg')}" alt="Dodi"></div>
    <div class="col" style="left:17mm;top:14mm;width:110mm">
      ${eyebrow(T.notes.eyebrow)}
      <h2 class="sec-title">${T.notes.title}</h2>
    </div>
    <div class="qa" style="left:17mm;top:46mm;width:104mm">${T.notes.qa.map(([q, a]) => `<div><h5>${q}</h5><p>${a}</p></div>`).join('')}</div>
    <div class="safety" style="left:128mm;top:46mm;width:68mm">
      <p class="sf-h">${I.shield()}<span>${T.notes.safetyTitle}</span></p>
      <ul>${T.notes.safety.map((s) => `<li>${I.check()}<span>${s}</span></li>`).join('')}</ul>
    </div>
    <div class="ask" style="left:128mm;top:150mm;width:68mm">
      <p class="ask-h">${T.notes.askTitle}</p>
      <p class="ask-l">${I.chat()}<span>${T.notes.askWhatsapp}</span></p>
      <p class="ask-l">${I.mail()}<span>${T.colophon.email}</span></p>
    </div>`);

  /* 46 — index */
  page(46, { cls: 'pg-index', ch: 8, folio: true }, () => {
    const rows = Object.keys(MP.products).map((s) => {
      const nm = MP.scents[s] ? `${T.index.perfumePrefix} · ${T.p[s].name}` : pname(s);
      return `<tr><td class="c">${s}</td><td class="nm">${nm}</td><td>${MP.products[s].size}</td><td class="bc">${MP.products[s].barcode}</td><td class="pg">${MP.products[s].page}</td></tr>`;
    }).sort();
    const sets = Object.keys(MP.sets).map((c) => `<tr><td class="c">${c}</td><td class="nm">${T.sets[c].name}</td><td>${MP.sets[c].items.length} ${T.itemWord}</td><td class="bc">—</td><td class="pg">${MP.sets[c].page}</td></tr>`);
    return `
    <div class="col" style="left:14mm;top:14mm;width:180mm">
      ${eyebrow(T.index.eyebrow)}
      <h2 class="sec-title s">${T.index.title}</h2>
    </div>
    <table class="index" style="left:14mm;top:38mm;width:179mm">
      <thead><tr>${T.index.cols.map((c) => `<th>${c}</th>`).join('')}</tr></thead>
      <tbody>${rows.join('')}</tbody>
      <tbody class="sets"><tr class="grp"><th colspan="5">${T.index.setsTitle}</th></tr>${sets.join('')}</tbody>
    </table>`;
  });

  /* 47 — contacts (the Künye block came out on 2026-10-20, review note: «47. sayfadaki künye kısmını kaldır») */
  page(47, { cls: 'pg-colophon', ch: 8, folio: true }, () => `
    <img class="colo-logo" src="${brand('studio-logo.svg')}" alt="MelomyPet">
    <div class="col" style="left:17mm;top:40mm;width:96mm">
      ${eyebrow(T.colophon.contactTitle)}
      <p class="colo-co">${T.colophon.company}</p>
      <p class="colo-l">${T.colophon.address}</p>
      <p class="colo-l ic">${I.phone()}${T.colophon.phone}</p>
      <p class="colo-l ic">${I.chat()}${T.colophon.whatsapp}</p>
      <p class="colo-l ic">${I.mail()}${T.colophon.email}</p>
      <p class="colo-l ic">${I.globe()}${T.colophon.web}</p>
      <p class="colo-l ic">${I.insta()}${T.colophon.social}</p>
    </div>
    <div class="qr-box" style="left:132mm;top:40mm;width:64mm"><img class="qr" src="${MP.imgURL ? MP.imgURL('qr-melomypet.svg') : 'assets/img/qr-melomypet.svg'}" alt="QR · melomypet.com"><p>${T.colophon.qr}</p><b>${T.colophon.web}</b></div>
    <div class="col fine" style="left:17mm;top:146mm;width:179mm">
      <p>${T.colophon.images}</p>
      <p>${T.colophon.legal}</p>
      <p class="copy">${T.colophon.copyright}</p>
    </div>
    ${seal('right:16mm;top:112mm;width:24mm;height:24mm')}`);

  /* 48 — BACK COVER */
  page(48, { cls: 'pg-back', folio: false }, () => `
    ${fullImg('back', '62% 40%')}
    <div class="scrim-back"></div>
    <div class="back-text">
      <p class="op-time">${T.back.time}</p>
      <h2 class="back-title">${T.back.title}</h2>
      ${hand(T.back.hand, '', '', 'light inline')}
    </div>
    <div class="back-foot">
      <img src="${brand('studio-logo-white.svg')}" alt="MelomyPet">
      <p>${T.back.tagline}</p>
      <p class="u">${T.back.url} · ${T.back.social}</p>
    </div>`);

  /* ---------- assembly ---------- */
  MP.pageCount = 48;
  MP.buildPages = function (lang) {
    T = MP.content[lang];
    const runTitle = (p) => (p.ch ? T.chapters[p.ch].name : T.meta.running);
    return P.map((p) => {
      const side = p.n % 2 === 0 ? 'left' : 'right';
      const ch = p.ch ? MP.chapters[p.ch] : null;
      const vars = ch ? `--tint:${ch.tint};--accent:${ch.accent};` : '';
      const folio = p.folio === false ? '' : `<div class="folio ${side} ${p.folioLight ? 'light' : ''} ${p.folioNight ? 'night' : ''}">${side === 'left' ? `<b>${p.n}</b><span>${runTitle(p)}</span>` : `<span>${runTitle(p)}</span><b>${p.n}</b>`}</div>`;
      const tabMark = p.ch === 8 ? MP.icon.moon() : T.chapters[p.ch] ? T.chapters[p.ch].no : '';
      const tab = p.ch ? `<div class="tab ${side}" style="top:${18 + (p.ch - 1) * 23}mm"><span>${tabMark}</span></div>` : '';
      return `<section class="page ${side} ${p.cls || ''}" data-n="${p.n}" style="${vars}">${p.render()}${folio}${tab}</section>`;
    });
  };
})();
